export default class Target {
  constructor(timestamp, velocity, coordinates) {
    this.timestamp = timestamp
    this.velocity = velocity
    this.coordinates = coordinates
  }
}